import * as fromExternalAppConfigAction from '../actions/externalAppData.action';
import { IExternalAppData } from '../models/externalAppData.model';

export interface State {
  config: IExternalAppData | undefined
};

const initialState: State = {
  config: { sourceApp: '', showModal: false, preloadCompany: true, fromRedirect: false }
};

export function reducer(state = initialState, action: any) {
  switch(action.type) {
    case fromExternalAppConfigAction.ActionTypes.SET_INITIAL_DATA:
      if (state.config.fromRedirect) {
        const paymentType = state.config.paymentType;
        return {...state, config: state.config, paymentType: paymentType }
      } else {
        if (state.config) {
          if (state.config.returnUrl) {
            action.payload.returnUrl = state.config.returnUrl;
          }
        }
        return {...state, config: action.payload, paymentType: undefined }
      }
    case fromExternalAppConfigAction.ActionTypes.SET_ADVANCED_PAYMENT_DATA:
      return {...state, config: action.payload, paymentType: 'ADVANCED' }
    case fromExternalAppConfigAction.ActionTypes.SET_REGULAR_PAYMENT_DATA:
      return {...state, config: action.payload, paymentType: 'REGULAR' }
    case fromExternalAppConfigAction.ActionTypes.SET_FINANCIAL_VIEW: {
        if (state.config) {
          state.config.fromFinancialView = action.payload;
        }
        return {...state, config: state.config }
      }
    case fromExternalAppConfigAction.ActionTypes.SET_FROM_REDIRECT: {
      if (state.config) {
        state.config.fromRedirect = action.payload;
      }
      return {...state, config: state.config }
    }
    default:
      return state;
    }
  }

